"use client";
import React, { useRef, useState } from "react";
import countries from "../../../../public/countries.json";
import states from "../../../../public/states.json";
import RegistrationAlert from "@/app/_components/alerts/RegistrationAlert";
// import RegistrationAlert from "../Alerts/RegistrationAlert";
export default function MachineRegistrationForm({ models }) {
  const endUserCompanyRef = useRef("");
  const endUserContactRef = useRef("");
  const endUserJobDescriptionRef = useRef("");
  const endUserAddressRef = useRef("");
  const endUserCityRef = useRef("");
  const endUserStateRef = useRef("");
  const endUserCountryRef = useRef("");
  const endUserZipRef = useRef("");
  const endUserPhoneRef = useRef("");
  const endUserEmailRef = useRef("");
  const serialRef = useRef("");
  const modelRef = useRef("");
  const signatureRef = useRef("");
  const installingDealerRef = useRef("");
  const installBranchRef = useRef("");
  const installDateRef = useRef("");
  const installedByRef = useRef("");
  const installedByEmailRef = useRef("");
  const masterDistributorRef = useRef("");
  const signature2Ref = useRef("");
  const termsRef = useRef("");
  const terms2Ref = useRef("");
  const rentalRef = useRef("");
  let initState = {
    endUserCompany: "",
    endUserContact: "",
    endUserJobDescription: "",
    endUserAddress: "",
    endUserCity: "",
    endUserState: "",
    endUserCountry: "USA",
    endUserZip: "",
    endUserPhone: "",
    endUserEmail: "",
    serial: "",
    model: "",
    signature: "",
    installingDealer: "",
    installBranch: "",
    installDate: "",
    installedBy: "",
    installedByEmail: "",
    masterDistributor: "",
    signature2: "",
    terms: 0,
    terms2: 0,
    rental: 0,
    origin: "TL_Website",
  };
  const [formData, setFormData] = useState(initState);
  const [errors, setErrors] = useState({});
  const [isBoxOneChecked, setIsBoxOneChecked] = useState(false);
  const [isBoxTwoChecked, setIsBoxTwoChecked] = useState(false);
  const [registeredSerial, setRegisteredSerial] = useState("");
  const [registeredURL, setRegisteredURL] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertStatus, setAlertStatus] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  countries.sort((a, b) => {
    if (a.name === "United States") {
      return -1;
    }
    if (b.name === "United States") {
      return 1;
    }
    return a.name.localeCompare(b.name);
  });

  // sort states alphabetically but keep Outside US and Canada at the top
  states.sort((a, b) => {
    if (a.abbreviation === "Outside US and Canada") {
      return -1;
    }
    if (b.abbreviation === "Outside US and Canada") {
      return 1;
    }
    return a.abbreviation.localeCompare(b.abbreviation);
  });
  const scrollToError = (firstErrorKey) => {
    const errorRefs = {
      endUserCompany: endUserCompanyRef,
      endUserContact: endUserContactRef,
      endUserJobDescription: endUserJobDescriptionRef,
      endUserAddress: endUserAddressRef,
      endUserCity: endUserCityRef,
      endUserState: endUserStateRef,
      endUserCountry: endUserCountryRef,
      endUserZip: endUserZipRef,
      endUserPhone: endUserPhoneRef,
      endUserEmail: endUserEmailRef,
      serial: serialRef,
      model: modelRef,
      signature: signatureRef,
      installingDealer: installingDealerRef,
      installBranch: installBranchRef,
      installDate: installDateRef,
      installedBy: installedByRef,
      installedByEmail: installedByEmailRef,
      masterDistributor: masterDistributorRef,
      signature2: signature2Ref,
      terms: termsRef,
      terms2: terms2Ref,
    };
    if (errorRefs[firstErrorKey] && errorRefs[firstErrorKey].current) {
      errorRefs[firstErrorKey].current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };
  const validateForm = () => {
    const newErrors = {};
    if (!isBoxOneChecked) {
      newErrors.terms = "You must agree to the terms";
    }
    if (!isBoxTwoChecked) {
      newErrors.terms2 = "You must agree to the terms";
    }
    if (!formData.endUserCompany) {
      newErrors.endUserCompany = "Company name is required";
    } else if (!/^[a-zA-Z0-9\s]+$/.test(formData.endUserCompany)) {
      newErrors.endUserCompany =
        "Company name must only contain letters, numbers, and spaces";
    } else if (formData.endUserCompany.length > 50) {
      newErrors.endUserCompany = "Company name must not exceed 50 characters";
    }

    // Contact name validation
    if (!formData.endUserContact) {
      newErrors.endUserContact = "Contact name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.endUserContact)) {
      newErrors.endUserContact =
        "Contact name must only contain letters and spaces";
    } else if (formData.endUserContact.length > 50) {
      newErrors.endUserContact = "Contact name must not exceed 50 characters";
    }

    // Job Title validation
    if (!formData.endUserJobDescription) {
      newErrors.endUserJobDescription = "Job Title is required";
    } else if (formData.endUserJobDescription.length > 50) {
      newErrors.endUserJobDescription =
        "Job Title must not exceed 50 characters";
    }

    // Address validation
    if (!formData.endUserAddress) {
      newErrors.endUserAddress = "Address is required";
    } else if (formData.endUserAddress.length > 50) {
      newErrors.endUserAddress = "Address must not exceed 50 characters";
    }

    if (!formData.endUserCity) {
      newErrors.endUserCity = "City is required";
    } else if (formData.endUserCity.length > 50) {
      newErrors.endUserCity = "City must not exceed 50 characters";
    }

    // State validation
    if (!formData.endUserState) {
      newErrors.endUserState = "State is required";
    } else if (formData.endUserState.length > 50) {
      newErrors.endUserState = "State must not exceed 50 characters";
    }

    // Country validation
    if (!formData.endUserCountry) {
      newErrors.endUserCountry = "Country is required";
    } else if (formData.endUserCountry.length > 50) {
      newErrors.endUserCountry = "Country must not exceed 50 characters";
    }

    // Zip validation
    if (!formData.endUserZip) {
      newErrors.endUserZip = "Zip is required";
    } else if (formData.endUserZip.length > 50) {
      newErrors.endUserZip = "Zip must not exceed 50 characters";
    }

    if (!formData.endUserPhone) {
      newErrors.endUserPhone = "Phone is required";
    } else {
      const phoneRegex = /^\+?\d{1,3}([- ]?\d{1,4}){2,}$/;

      if (!phoneRegex.test(formData.endUserPhone)) {
        newErrors.endUserPhone =
          "Invalid phone number. Please enter a valid format, e.g., 814-538-0204 or +1 814-538-0204.";
      }
    }

    // Validate email address
    if (!formData.endUserEmail) {
      newErrors.endUserEmail = "Email is required";
    } else {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailRegex.test(formData.endUserEmail)) {
        newErrors.endUserEmail = "Invalid email address";
      }
      if (formData.endUserEmail.length > 50) {
        newErrors.endUserEmail = "Email address exceeds maximum length";
      }
    }

    // Validate serial number
    if (!formData.serial) {
      newErrors.serial = "Serial is required";
    } else {
      const serialRegex = /^[A-Z0-9]+$/;
      if (!serialRegex.test(formData.serial)) {
        newErrors.serial = "Invalid serial number";
      }
      if (formData.serial.length > 20) {
        newErrors.serial = "Serial number exceeds maximum length";
      }
    }

    // Validate model name
    if (!formData.model) {
      newErrors.model = "Model is required";
    } else {
      const modelRegex = /^[a-zA-Z0-9\s-]+$/; // Allow dashes in the model name
      if (!modelRegex.test(formData.model)) {
        newErrors.model = "Invalid model name";
      }
      if (formData.model.length > 50) {
        newErrors.model = "Model name exceeds maximum length";
      }
    }

    if (!formData.signature) {
      newErrors.signature = "Signature is required";
    } else if (formData.signature.length > 100) {
      newErrors.signature = "Signature is too long";
    }

    // Validate installing dealer
    if (!formData.installingDealer) {
      newErrors.installingDealer = "Installing dealer is required";
    } else if (formData.installingDealer.length > 50) {
      newErrors.installingDealer = "Installing dealer name is too long";
    }

    // Validate installing branch
    if (!formData.installBranch) {
      newErrors.installBranch = "Installing Branch is required";
    } else if (formData.installBranch.length > 50) {
      newErrors.installBranch = "Installing Branch name is too long";
    }

    // Validate installer's name
    if (!formData.installedBy) {
      newErrors.installedBy = "Installer's name is required";
    } else if (formData.installedBy.length > 50) {
      newErrors.installedBy = "Installer's name is too long";
    }

    // Validate installer's email
    if (!formData.installedByEmail) {
      newErrors.installedByEmail = "Installer's email is required";
    } else {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailRegex.test(formData.installedByEmail)) {
        newErrors.installedByEmail = "Invalid installer's email";
      }
      if (formData.installedByEmail.length > 50) {
        newErrors.installedByEmail = "Installer's email is too long";
      }
    }

    // Validate master distributor (optional; max length only if provided)
    if (formData.masterDistributor && formData.masterDistributor.length > 50) {
      newErrors.masterDistributor = "Master Distributor name is too long";
    }

    // Validate second signature
    if (!formData.signature2) {
      newErrors.signature2 = "Second signature is required";
    } else if (formData.signature2.length > 100) {
      newErrors.signature2 = "Second signature is too long";
    }
    // Add more validations for other fields here

    setErrors(newErrors);
    const firstErrorKey = Object.keys(newErrors)[0];
    if (firstErrorKey) {
      scrollToError(firstErrorKey);
    }
    return Object.keys(newErrors).length === 0; // Return true if there are no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      await registerMachine(formData);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckbox = (event) => {
    const id = event.target.id;

    if (id === "terms") {
      setIsBoxOneChecked((prevState) => !prevState);
      formData.terms = isBoxOneChecked ? 0 : 1;
    } else if (id === "terms2") {
      setIsBoxTwoChecked((prevState) => !prevState);
      formData.terms2 = isBoxTwoChecked ? 0 : 1;
    }
  };

  const registerMachine = async (data) => {
    let response = await fetch("/api/registerMachine", {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    });
    response = await response.json();
    if (response.success) {
      setAlertStatus("Success");
      setRegisteredSerial(response.serial);
      setRegisteredURL(response.url);
      setShowAlert(true);
      setAlertMessage(response.message);
      return response;
    } else {
      setAlertStatus("Failed");
      setShowAlert(true);
      const { errors } = response;
      const errorMessages = errors.map((errorObj) => errorObj.error);
      setAlertMessage(errorMessages.join(", "));
      return response;
    }
  };
  const closeAlert = () => {
    setShowAlert(false);
    setFormData(initState);
    setIsBoxOneChecked(false);
    setIsBoxTwoChecked(false);
  };

  return (
    <>
      {showAlert && (
        <RegistrationAlert
          showAlert={showAlert}
          alertStatus={alertStatus}
          registeredURL={registeredURL}
          registeredSerial={registeredSerial}
          closeAlert={closeAlert}
        >
          <p>{alertMessage}</p>
        </RegistrationAlert>
      )}
      <div className="register-form-wrapper">
        <div>
          {/* <button onClick={fillForm}>Fill Form</button> */}
          <h1>Product Registration</h1>
          <form className="register-form" onSubmit={handleSubmit}>
            <div className="two-column">
              <div className="form-group">
                <label>
                  Company Name
                  {errors.endUserCompany && (
                    <label className="error">{errors.endUserCompany}</label>
                  )}
                </label>
                <input
                  type={"text"}
                  name={"endUserCompany"}
                  placeholder={``}
                  ref={endUserCompanyRef}
                  value={formData.endUserCompany}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  Contact Name
                  {errors.endUserContact && (
                    <label className="error">{errors.endUserContact}</label>
                  )}
                </label>

                <input
                  type={"text"}
                  name={"endUserContact"}
                  placeholder={``}
                  ref={endUserContactRef}
                  value={formData.endUserContact}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="two-column">
              <div className="form-group">
                <label>
                  Contact Title
                  {errors.endUserJobDescription && (
                    <label className="error">
                      {errors.endUserJobDescription}
                    </label>
                  )}
                </label>
                <input
                  type={"text"}
                  name={"endUserJobDescription"}
                  placeholder={``}
                  ref={endUserJobDescriptionRef}
                  value={formData.endUserJobDescription}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  Address
                  {errors.endUserAddress && (
                    <label className="error">{errors.endUserAddress}</label>
                  )}
                </label>
                <input
                  type={"text"}
                  name={"endUserAddress"}
                  placeholder={``}
                  ref={endUserAddressRef}
                  value={formData.endUserAddress}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="three-column">
              <div className="form-group">
                <label>
                  Country
                  {errors.endUserCountry && (
                    <label className="error">{errors.endUserCountry}</label>
                  )}
                </label>
                {/* <input
                  type={"text"}
                  name={"endUserCountry"}
                  placeholder={``}
                  ref={endUserCountryRef}
                  value={endUserCountryRef.current.value}
                  onChange={handleChange}
                /> */}
                <select
                  onChange={handleChange}
                  value={formData.country}
                  name="endUserCountry"
                  id="country"
                  ref={endUserCountryRef}
                >
                  <option value={""}>Select Country</option>
                  {countries.map((country, index) => (
                    <option value={country.id} key={index}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>
                  City
                  {errors.endUserCity && (
                    <label className="error">{errors.endUserCity}</label>
                  )}
                </label>

                <input
                  type={"text"}
                  name={"endUserCity"}
                  placeholder={``}
                  ref={endUserCityRef}
                  value={formData.endUserCity}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  State
                  {errors.endUserState && (
                    <label className="error">{errors.endUserState}</label>
                  )}
                </label>
                <select
                  id="endUserState"
                  name="endUserState"
                  ref={endUserStateRef}
                  value={formData.state}
                  placeholder="State"
                  onChange={handleChange}
                >
                  <option value="">Choose State</option>
                  {states.map((state, index) => (
                    <option value={state.abbreviation} key={state.index}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="two-column">
              <div className="form-group">
                <label>
                  Zip
                  {errors.endUserZip && (
                    <label className="error">{errors.endUserZip}</label>
                  )}
                </label>
                <input
                  type={"text"}
                  name={"endUserZip"}
                  placeholder={``}
                  ref={endUserZipRef}
                  value={formData.endUserZip}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  Email
                  {errors.endUserEmail && (
                    <label className="error">{errors.endUserEmail}</label>
                  )}
                </label>

                <input
                  type={"text"}
                  name={"endUserEmail"}
                  placeholder={``}
                  ref={endUserEmailRef}
                  value={formData.endUserEmail}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="two-column">
              <div className="form-group">
                <label>
                  Phone
                  {errors.endUserPhone && (
                    <label className="error">{errors.endUserPhone}</label>
                  )}
                </label>

                <input
                  type="tel"
                  id="phone"
                  name={"endUserPhone"}
                  placeholder={``}
                  ref={endUserPhoneRef}
                  value={formData.endUserPhone}
                  onChange={handleChange}
                />
              </div>

              {/* Serial Number */}
              <div className="form-group">
                <label>
                  Serial Number
                  {errors.serial && (
                    <label className="error">{errors.serial}</label>
                  )}
                </label>

                <input
                  type={"text"}
                  name={"serial"}
                  placeholder={``}
                  ref={serialRef}
                  value={formData.serial}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  Model Number
                  {errors.model && (
                    <label className="error">{errors.model}</label>
                  )}
                </label>
                <select
                  id="model"
                  name="model"
                  ref={modelRef}
                  value={formData.model}
                  placeholder="Select a Model"
                  onChange={handleChange}
                >
                  <option value="">Choose Model</option>
                  {models.map((model, index) => (
                    <option value={model.partNumber} key={index}>
                      {model.machineDesc}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <h4>Terms of Acceptance</h4>
            <ul>
              <li>
                I have received copies of the Operators and Parts manuals
                applicable to this machine and understand that they contain
                important information about the safe use and proper maintenance
                of this machine.
              </li>
              <li>
                I understand that all operators must read, understand and follow
                the instructions in the Operators Manual, and agree they will be
                trained in the safe use of this machine in accordance with the
                warnings and instructions provided on the machine and contained
                in the Operator’s Manual provided with the machine prior to
                operating it.
              </li>
              <li>
                I am authorized to make the foregoing acknowledgments on behalf
                of the End User indicated above and on behalf of my company am
                authorized to submit this Warranty Registration.
              </li>
            </ul>
            <h4>End User Representative (Electronic Signature)</h4>
            <div className="form-group">
              <label>Electronic Signature</label>
              {errors.signature && (
                <label className="error">{errors.signature}</label>
              )}
              <input
                type={"text"}
                name={"signature"}
                placeholder={``}
                ref={signatureRef}
                value={formData.signature}
                onChange={handleChange}
              />
            </div>
            <div className="form-group flex">
              <input
                type="checkbox"
                id="terms"
                name="terms"
                ref={termsRef}
                onChange={handleCheckbox}
                checked={isBoxOneChecked}
              />
              <label>
                I understand that checking this box constitutes a legal
                signature confirming that I acknowledge and agree to the above
                Terms of Acceptance.
                {errors.terms && (
                  <label className="error">{errors.terms}</label>
                )}
              </label>
            </div>
            {/* Installing Distributor */}
            <br />
            <div className="two-column">
              <div className="form-group">
                <label>
                  Installing Distributor
                  {errors.installingDealer && (
                    <label className="error">{errors.installingDealer}</label>
                  )}
                </label>

                <input
                  type={"text"}
                  name={"installingDealer"}
                  placeholder={``}
                  ref={installingDealerRef}
                  value={formData.installingDealer}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  Installing Distributor Branch
                  {errors.installBranch && (
                    <label className="error">{errors.installBranch}</label>
                  )}
                </label>

                <input
                  type={"text"}
                  name={"installBranch"}
                  placeholder={``}
                  ref={installBranchRef}
                  value={formData.installBranch}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  Master Distributor
                  {errors.masterDistributor && (
                    <label className="error">{errors.masterDistributor}</label>
                  )}
                </label>

                <input
                  type={"text"}
                  name={"masterDistributor"}
                  placeholder={``}
                  ref={masterDistributorRef}
                  value={formData.masterDistributor}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>
                  Installing By Name
                  {errors.installedBy && (
                    <label className="error">{errors.installedBy}</label>
                  )}
                </label>

                <input
                  type={"text"}
                  name={"installedBy"}
                  placeholder={``}
                  ref={installedByRef}
                  value={formData.installedBy}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  Installing By Email
                  {errors.installedByEmail && (
                    <label className="error">{errors.installedByEmail}</label>
                  )}
                </label>

                <input
                  type={"email"}
                  name={"installedByEmail"}
                  placeholder={``}
                  ref={installedByEmailRef}
                  value={formData.installedByEmail}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  Installation Date
                  {errors.installDate && (
                    <label className="error">{errors.installDate}</label>
                  )}
                </label>
                <input
                  type="date"
                  name="installDate"
                  ref={installDateRef}
                  value={formData.installDate}
                  onChange={handleChange}
                />
              </div>
            </div>
            <h4>Installed by (Electronic Signature)</h4>
            <div className="form-group">
              <label>
                Electronic Signature
                {errors.signature2 && (
                  <label className="error">{errors.signature2}</label>
                )}
              </label>
              <input
                type={"text"}
                name={"signature2"}
                placeholder={``}
                ref={signature2Ref}
                value={formData.signature2}
                onChange={handleChange}
              />
            </div>
            <div className="form-group flex">
              <input
                type="checkbox"
                id="terms2"
                name="terms2"
                ref={terms2Ref}
                onChange={handleCheckbox}
                checked={isBoxTwoChecked}
              />
              <label>
                I understand that checking this box consitutes a legal signature
                confirming that I installed the piece of equipment with the End
                User indicated above and provided them training and manuals.
                {errors.terms2 && (
                  <label className="error">{errors.terms2}</label>
                )}
              </label>
            </div>
            <button className="cta-button" type="submit">
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
